import { AnyProfile, FormFields, Profesor, ProfileRole } from '../../../types'

export const professorFields = ({
  state,
  userRole,
}: {
  state: AnyProfile
  userRole: ProfileRole | null
}): FormFields[] => {
  return [
    {
      title: 'Clases',
      rowRight: [
        {
          type: 'menu',
          label: 'experticeMenu',
          id: 'activities',
          value: state.activities,
          userType: userRole === 'admin' ? userRole : state.role,
        },
      ],
    },
    {
      title: 'Aptitudes/ estudios',
      rowRight: [
        {
          type: 'menu',
          label: 'experticeMenu',
          id: 'experienceType',
          value: state.experienceType,
          userType: userRole === 'admin' ? userRole : state.role,
        },
      ],
    },
    {
      title: 'Experiencia (en años)',
      type: 'multipleColumns',
      rowRight: [
        {
          type: 'number',
          label: 'Antigüedad en la metodologia',
          id: 'yearsTeaching',
          value: (state as Profesor).yearsTeaching ?? 0,
          inputClass: 'profession-data',
          subText: 'años',
        },
        {
          type: 'number',
          label: 'Experiencia artistica',
          id: 'yearsOfExperience',
          value: (state as Profesor).yearsOfExperience ?? 0,
          inputClass: 'profession-data',
          subText: 'años',
        },
        {
          type: 'number',
          label: 'Espectaculos realizados',
          id: 'yearsSinging',
          value: (state as Profesor).yearsSinging ?? 0,
          inputClass: 'profession-data',
        },
        {
          type: 'number',
          label: 'Acompaño a',
          id: 'yearsOfMethodology',
          value: (state as Profesor).yearsOfMethodology ?? 0,
          inputClass: 'profession-data',
          subText: 'alumnos',
        },
      ],
    },
    {
      title: 'Biografía',
      rowRight: [
        {
          type: 'text',
          label: '',
          id: 'biography',
          value: (state as Profesor).biography ?? '',
        },
      ],
    },
  ]
}
